import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  NgZone,
  Input,
  ApplicationRef,
  SimpleChanges,
  OnInit,
  OnDestroy,
} from "@angular/core";
import {
  CalendarSearchService,
  CalendarSearchResult,
} from "./services/calendar-search.service";
import { Subscription, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
@Component({
  selector: "icn-calendar-search",
  templateUrl: "./calendar-search.component.html",
  styleUrls: ["./calendar-search.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarSearchComponent implements OnInit, OnDestroy {
  term = "";
  resultUpdateRef: Subscription;
  currentHighlight = 1;
  searchDebounce: Subject<string> = new Subject<string>();
  searchResult: CalendarSearchResult;

  constructor(
    private calendarSearchService: CalendarSearchService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.calendarSearchService.term = "";
    this.resultUpdateRef = this.calendarSearchService.resultUpdate.subscribe(
      (result) => {
        this.searchResult = result;
        this.changeDetectorRef.markForCheck();
      },
    );
    this.searchDebounce
      .pipe(debounceTime(200), distinctUntilChanged())
      .subscribe(() => this.search());
    this.searchResult = this.calendarSearchService.latestResults;
    this.currentHighlight =
      this.calendarSearchService.currentHighlightedIndex + 1;
    this.term = this.calendarSearchService.term;
  }

  ngOnDestroy(): void {
    this.calendarSearchService.term = "";
    if (this.resultUpdateRef) {
      this.resultUpdateRef.unsubscribe();
    }
    if (this.searchDebounce) {
      this.searchDebounce.unsubscribe();
    }
  }

  onKeyboardEvent(e: KeyboardEvent) {
    this.searchDebounce.next((e.srcElement as HTMLInputElement).value);
  }
  onClipboardEvent(e: ClipboardEvent) {
    this.searchDebounce.next(e.clipboardData.getData("Text"));
  }

  search(event?: MouseEvent) {
    this.calendarSearchService.term = this.term;
    this.currentHighlight = 1;
  }

  CurrentHighlightIndex() {
    return this.currentHighlight;
  }

  previousResult() {
    this.calendarSearchService.highlightPrevious();

    if (this.currentHighlight === 1) {
      this.currentHighlight = this.searchResult.matches;
    } else {
      this.currentHighlight--;
    }
  }

  nextResult() {
    this.calendarSearchService.highlightNext();

    if (this.currentHighlight === this.searchResult.matches) {
      this.currentHighlight = 1;
    } else {
      this.currentHighlight++;
    }
  }

  clearSearch(event) {
    this.term = "";
    this.calendarSearchService.term = "";
    this.search(event);
  }
}
